import script from "./CommonSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonSelect.vue?vue&type=script&setup=true&lang=js"

import "./CommonSelect.vue?vue&type=style&index=0&id=2d895d71&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d895d71"]])

export default __exports__